import { Button, Form, InputNumber, Select, SelectProps } from "antd";
import classes from "../ExternalBankContent.module.css";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { SELECT_BANK_STATUSES } from "../../../../../store/selectors/authSliceLoginSelector";
import { useChangeApplicationStatus } from "../hooks/useChangeApplicationStatus";

export const ExternalBankBaseInfo = () => {
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );

  const bank_statuses = useAppSelector(SELECT_BANK_STATUSES);

  const selectOptionsBankStatuses: SelectProps["options"] = bank_statuses?.map(
    (item) => {
      return { value: item.id, label: item?.title };
    },
  );

  const { handleSubmitForm, isLoadingEditBank } = useChangeApplicationStatus();

  return (
    <Form
      key={activeBankInfo.bank_id}
      onFinish={handleSubmitForm}
      layout="vertical"
      className={classes.form}
    >
      <div className={classes.infoContainer}>
        <Form.Item
          name={"platform_app_id"}
          layout="vertical"
          label={<span className={classes.formItemLabel}>Номер заявки</span>}
        >
          <InputNumber size="large" defaultValue={activeBankInfo.platform_app_id || undefined} className={classes.formItemInput}/>
        </Form.Item>

        <Form.Item
          name={"status_id"}
          layout="vertical"
          label={<span className={classes.formItemLabel}>Статус</span>}
        >
          <Select
            defaultValue={activeBankInfo.status_id}
            value={activeBankInfo.status_id}
            options={selectOptionsBankStatuses}
          />
        </Form.Item>
      </div>

      <div className={classes.submitFormContainer}>
        <Button
          size="middle"
          disabled={isLoadingEditBank}
          loading={isLoadingEditBank}
          htmlType="submit"
          color="primary"
          variant="solid"
          className={classes.submitBtn}
        >
          Сохранить изменения
        </Button>
      </div>
    </Form>
  );
};
